import type { ReactNode } from 'react'
import { cx } from './internal/cx'
import './Chip.css'

export type ChipProps = {
  selected?: boolean
  onClick?: () => void
  children: ReactNode
}

/** Filter chip. Selected state uses aria-pressed plus text weight — never color alone. */
export function Chip({ selected = false, onClick, children }: ChipProps) {
  return (
    <button
      type="button"
      className={cx('ui-chip', selected && 'ui-chip--selected')}
      aria-pressed={selected}
      onClick={onClick}
    >
      {children}
    </button>
  )
}
